(() => {
  const dates = ['2026-10-03T06:20:00+02:00','2026-10-10T08:00:00+02:00','2026-10-17T08:00:00+02:00','2026-10-24T08:00:00+02:00','2026-10-31T08:00:00+01:00','2026-11-07T08:00:00+01:00','2026-11-14T08:00:00+01:00','2026-11-21T08:00:00+01:00'].map(Date.parse);
  function state(now, releases = dates) {
    const next = releases.find(time => time > now);
    const seconds = next ? Math.max(0, Math.ceil((next-now)/1000)) : 0;
    return {next,week:next?releases.indexOf(next)+1:null,days:Math.floor(seconds/86400),hours:Math.floor(seconds%86400/3600),minutes:Math.floor(seconds%3600/60),seconds:seconds%60,complete:!next};
  }
  const launchNoticeAt=Date.parse('2026-10-03T06:30:00+02:00');
  function launchState(now,releases=dates) {
    const cohort=releases.length===dates.length && releases.every((time,index)=>time===dates[index]);
    if(cohort && now<launchNoticeAt) {
      return {...state(now,[launchNoticeAt]),launchPhase:'before'};
    }
    return state(now,releases);
  }
  if(typeof module !== 'undefined' && module.exports) module.exports = {state,launchState,launchNoticeAt,dates};
  if(typeof document === 'undefined') return;
  function init(root) {
    const timer=root.querySelector('[data-countdown]');
    if(!timer || timer.dataset.initialized) return;
    timer.dataset.initialized='true';
    const text=JSON.parse(root.querySelector('[data-mkal-text]').textContent);
    if(root.dataset.awaitingShipment==='true') {
      timer.querySelector('[data-countdown-digits]').hidden=true;
      timer.querySelector('[data-countdown-title]').textContent=text.awaiting_shipment_short;
      timer.querySelector('[data-countdown-date]').textContent='';
      return;
    }
    let interval, customReleases=null, previousTarget, previousContentTarget;
    const calendar=root.querySelector('[data-mkal-calendar]');
    if(calendar) {
      const releases=JSON.parse(calendar.textContent).map(Date.parse);
      if(releases.length===8 && releases.every(Number.isFinite))customReleases=releases.sort((a,b)=>a-b);
    }
    const dateFormat=new Intl.DateTimeFormat('de-DE',{day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit',timeZone:'Europe/Berlin'});
    function tick(){
      if(!root.isConnected){clearInterval(interval);return;}
      const value=launchState(Date.now(),customReleases ?? dates);
      const contentTarget=state(Date.now(),customReleases ?? dates).next;
      if(root.dataset.source==='shopify' && previousContentTarget && previousContentTarget<=Date.now() && contentTarget!==previousContentTarget && !root.dataset.refreshing) {
        root.dataset.refreshing='true';
        location.reload();
        return;
      }
      previousContentTarget=contentTarget;
      timer.querySelector('[data-countdown-digits]').hidden=value.complete || value.hideDigits===true;
      for(const key of ['days','hours','minutes','seconds'])timer.querySelector(`[data-countdown-${key}]`).textContent=String(value[key]).padStart(2,'0');
      if(value.next!==previousTarget || !timer.dataset.rendered){
        const english=document.documentElement.lang.startsWith('en');
        timer.querySelector('[data-countdown-title]').textContent=value.launchPhase ? (value.launchPhase==='before' ? (english?'Your start email arrives in':'Deine Startmail kommt in') : (english?'The Knit Along starts today':'Heute startet dein Knit Along')) : value.complete?text.countdown_complete:text.countdown_next;
        timer.querySelector('[data-countdown-date]').textContent=value.launchPhase ? (english?'03 October 2026, 06:30 · instructions available from 06:20 (German time)':'03.10.2026, 06:30 Uhr · Anleitung ab 06:20 Uhr verfügbar') : value.complete?text.countdown_complete_note:`${dateFormat.format(value.next)} ${text.countdown_timezone}`;
        previousTarget=value.next;timer.dataset.rendered='true';
      }
    }
    root.addEventListener('mkal:schedule',event=>{
      const releases=event.detail.weeks.map(w=>Date.parse(w.unlockAt));
      if(releases.length===8 && releases.every(Number.isFinite))customReleases=releases.sort((a,b)=>a-b);
      tick();
    });
    tick();interval=setInterval(tick,1000);
    document.addEventListener('visibilitychange',()=>{if(!document.hidden&&root.isConnected)tick();});
  }
  document.querySelectorAll('[data-mkal]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-mkal]').forEach(init));
})();
